import React from 'react';
import groupBy from 'lodash/groupBy';
import MuiAccordion from '@material-ui/core/Accordion';
import MuiAccordionDetails from '@material-ui/core/AccordionDetails';
import MuiAccordionSummary from '@material-ui/core/AccordionSummary';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import ExpandMore from '@material-ui/icons/ExpandMore';
import MuiTimeline from '@material-ui/lab/Timeline';
import TimelineConnector from '@material-ui/lab/TimelineConnector';
import MuiTimelineContent from '@material-ui/lab/TimelineContent';
import TimelineDot from '@material-ui/lab/TimelineDot';
import MuiTimelineItem from '@material-ui/lab/TimelineItem';
import TimelineSeparator from '@material-ui/lab/TimelineSeparator';
import { _F } from 'appI18n';
const useStyles = makeStyles(theme => ({
    timestamp: {
        width: 60,
        "& > span": {
            fontWeight: 600,
        },
    },
    title: {
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis"
    },
    description: {
        whiteSpace: 'pre-wrap',
    },
    root: {
        '& > div + div': {
            marginTop: theme.spacing(2),
        },
    },
    dayTitle: {
        marginBottom: theme.spacing(1),
        fontWeight: 600,
    },
    dayEvents: {}
}));
const Timeline = withStyles({
    root: {
        paddingLeft: 0,
        paddingRight: 0,
    }
})(MuiTimeline);
const TimelineItem = withStyles({
    missingOppositeContent: {
        "&:before": {
            display: "none"
        }
    }
})(MuiTimelineItem);
const TimelineContent = withStyles({
    root: {
        paddingRight: 0
    }
})(MuiTimelineContent);
const Accordion = withStyles({
    root: {
        border: '1px solid rgba(0, 0, 0, .145)',
        boxShadow: 'none',
        '&:not(:last-child)': {
            borderBottom: 0,
        },
        '&:before': {
            display: 'none',
        },
        '&$expanded': {
            margin: 'auto',
        },
    },
    expanded: {},
})(MuiAccordion);
const AccordionSummary = withStyles({
    root: {
        marginBottom: -1,
        minHeight: 56,
        '&$expanded': {
            minHeight: 56,
        },
    },
    content: {
        '&$expanded': {
            margin: '12px 0',
        },
    },
    expanded: {},
})(MuiAccordionSummary);
const AccordionDetails = withStyles((theme) => ({
    root: {
        borderTop: '1px solid rgba(0,0,0,.145)',
        padding: theme.spacing(2),
    },
}))(MuiAccordionDetails);
function TourEvent({ event }) {
    const classes = useStyles();
    return React.createElement(Accordion, null,
        React.createElement(AccordionSummary, { expandIcon: React.createElement(ExpandMore, null) },
            React.createElement("div", { className: classes.timestamp },
                React.createElement("span", null, event.time)),
            React.createElement("div", { className: classes.title }, event.title)),
        React.createElement(AccordionDetails, { className: classes.description }, event.description));
}
function TourDay({ dayNo, dayEvents, isLast }) {
    const classes = useStyles();
    return React.createElement(TimelineItem, null,
        React.createElement(TimelineSeparator, null,
            React.createElement(TimelineDot, { variant: "outlined" }),
            !isLast ? React.createElement(TimelineConnector, null) : null),
        React.createElement(TimelineContent, null,
            React.createElement(Typography, { variant: "subtitle2", component: "h5", className: classes.dayTitle }, _F('COMMON_DAY_NUMBER', dayNo)),
            React.createElement("div", { className: classes.dayEvents }, dayEvents.map((x, i) => React.createElement(TourEvent, { event: x, key: i })))));
}
export default function TourProgram({ events }) {
    const classes = useStyles();
    const groups = groupBy(events, x => x.day);
    const groupEntires = Object.entries(groups);
    return React.createElement("div", { className: classes.root },
        React.createElement(Timeline, { align: "left" }, groupEntires.map(([day, events], i) => React.createElement(TourDay, { dayNo: day, dayEvents: events, key: day, isLast: i == groupEntires.length - 1 }))));
}
